import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import ContactForm from '../components/ContactForm';

const Contact = () => {
  // Initialiser Google Ads
  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'AW-16912204930');
    }
  }, []);
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="section-header">
          <div className="section-badge">Nos moyens de contact</div>
          <h1 className="page-title">Contactez-nous</h1>
          <p className="section-description">
            Pour tous vos besoins en entretien de jardin, contactez-nous dès maintenant et bénéficiez d'un service rapide et professionnel !
          </p>
        </div>

        <div className="cards-grid" style={{marginTop: 'var(--spacing-xl)', marginBottom: '3rem'}}>
          <div className="modern-card">
            <div className="card-icon">
              <svg width="32" height="32" viewBox="0 0 512 512" fill="currentColor">
                <path d="M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z"></path>
              </svg>
            </div>
            <h3 className="card-title">Téléphone</h3>
            <p className="card-description">
              Appelez-nous pour un devis gratuit et rapide.
            </p>
            <a href="tel:+33769703585" className="card-link">
              (+33) 7 69 70 35 85
            </a>
          </div>

          <div className="modern-card">
            <div className="card-icon">
              <svg width="32" height="32" viewBox="0 0 512 512" fill="currentColor">
                <path d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805l-192 111.47L48 152.805V112h416zM48 400V214.398l192 111.47 192-111.47V400H48z"></path>
              </svg>
            </div>
            <h3 className="card-title">Email</h3>
            <p className="card-description">
              Envoyez-nous un message, nous vous répondrons rapidement.
            </p>
            <a href="mailto:contact@callgarden.fr" className="card-link">
              contact@callgarden.fr
            </a>
          </div>

          <div className="modern-card">
            <div className="card-icon">
              <svg width="32" height="32" viewBox="0 0 512 512" fill="currentColor">
                <path d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm0 464c-114.7 0-208-93.3-208-208S141.3 48 256 48s208 93.3 208 208-93.3 208-208 208z"></path>
                <path d="M256 128c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32s32-14.33 32-32V160c0-17.67-14.33-32-32-32z"></path>
                <circle cx="256" cy="352" r="16"></circle>
              </svg>
            </div>
            <h3 className="card-title">Demande de devis</h3>
            <p className="card-description">
              Remplissez notre formulaire de demande de devis en ligne.
            </p>
            <Link to="/demande-devis" className="card-link">
              Accéder au formulaire
            </Link>
          </div>
        </div>

        {/* Formulaire de contact basique */}
        <div className="modern-section" style={{paddingTop: '2rem'}}>
          <div className="section-container">
            <div style={{textAlign: 'center', marginBottom: '2rem'}}>
              <h2 className="section-title" style={{fontSize: 'clamp(1.5rem, 4vw, 2rem)', marginBottom: '1rem'}}>
                Formulaire de contact
              </h2>
              <p className="section-description" style={{maxWidth: '600px', margin: '0 auto'}}>
                Vous avez une question ou besoin d'informations ? Utilisez le formulaire ci-dessous pour nous contacter.
              </p>
            </div>
            <ContactForm type="basic" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
